import { createReducer, on } from '@ngrx/store';
import { setUserPrefs, deleteUserPrefs, clearENSAlertViewState } from './user-prefs.actions';
import { UserPrefs } from '@/app/api/UserPrefs-dto';

const initialState = new UserPrefs();

export const reducer = createReducer<UserPrefs>(
  initialState,
  on(setUserPrefs, (state, { payload }) => payload.userPrefs),
  on(deleteUserPrefs, () => new UserPrefs()),
  on(clearENSAlertViewState, (state) => {
    if (state) {
      const newState = structuredClone(state);
      if (newState.mainViewPrefs) {
        newState.mainViewPrefs.ENSAlertViewed = false;
      }
      return newState;
    }
    return state;
  })
);
